import * as types from './answer.types';
import * as constants from './answer.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const answerReducer = generateResourceReducer<types.IAnswer>({
  STORE: constants.STORE_ANSWER,
  CLEAR: constants.CLEAR_ANSWER,
});
